module.exports = __webpack_public_path__ + "img/bracket-12.effca6ad.svg";